import { useMemo } from "react";
import { useClinicsQuery } from "../../../../../../../api/queries/useClinicsQuery";
import { uiNotification } from "../../../../../../../services/UINotificationService";

export var useClinicOptions = (ignoreClinicId) => {
  var { data } = useClinicsQuery({
    onError: () => {
      uiNotification.error("Unable to fetch clinics. Try again later.");
    },
  });

  return useMemo(
    () =>
      data
        ?.filter((c) => c.id !== ignoreClinicId)
        ?.map((c) => ({
          label: c.name,
          value: c.id,
        })) || [],
    [data, ignoreClinicId],
  );
};
